module.exports = __webpack_public_path__ + "img/romance.e6a4a662.svg";